import { InsuranceType } from '@weave/schema-gen-ts/dist/schemas/insurance-verification/shared/enums.pb';
import { useGetCachedDentalCoverageInfoByPersonId } from '@frontend/api-insurance-detail';
import { TuuthFairyAPIResponse } from '../types/insurance-report-api.types';

export const useInsuranceReportData = (personId: string, locationId: string, insuranceType: InsuranceType) => {
  const {
    data: insuranceReportApiResponse,
    isError,
    isLoading,
  } = useGetCachedDentalCoverageInfoByPersonId(personId, locationId, insuranceType);

  return {
    insuranceReportApiResponse: insuranceReportApiResponse as unknown as TuuthFairyAPIResponse,
    isError,
    isLoading,
  };
};
